<template>
  <div id="MateriaprimaView">
    <!-- === HEADER SUPERIOR === -->
    <TopPanel
      :tabs="[
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' }
      ]"
      @year-changed="onYearChanged"
    />   
   
    <!-- === CUERPO PRINCIPAL === -->
    <div id="wrapper">
      <v-card id="left-wrapper">
        <h2 class="gray-font-text"><b>Materias primas y residuos orgánicos:</b></h2>
        <h3 class="gray-font-text">Empresa: Akapacha</h3>

        <DonutChart2
          :key="selectedYear"
          :data_chart="{
            chartSeries: materiaPrimaData.chartSeries,
            chartOptions: chartOptions,
            colors: ['#103E8E', '#5390EA']
          }"
        />

        <p class="gray-font-text">Gestión de residuos orgánicos:</p>
        <div class="d-flex justify-center">
          <v-btn
            v-for="(opcion, idx) in ['Siempre', 'A veces', 'Nunca']"
            :key="idx"
            class="mx-2 rounded-pill"
            :class="materiaPrimaData.gestionResiduos === opcion ? 'active' : 'unactive'"
            :color="materiaPrimaData.gestionResiduos === opcion ? 'primary' : 'grey lighten-2'"
            depressed
          >
            {{ opcion }}
          </v-btn>
        </div>

        <div>
          <p class="gray-font-text">Rango de residuos orgánicos reciclados o reutilizados:</p>
          <p class="mat_pri_number">{{ materiaPrimaData.reciclaje }}</p>
          <p class="gray-font-text">Rango de residuos orgánicos para compostaje:</p>
          <p class="mat_pri_number">{{ materiaPrimaData.compostaje }}</p>

          <p class="gray-font-text"><b>Nota:</b></p>
          <p class="gray-font-text">
            <small>{{ materiaPrimaData.nota }}</small>
          </p>
        </div>
      </v-card>

      <v-card id="right-wrapper">
        <!-- 👇 Esta clave (key) fuerza la recreación del SankeyChart al cambiar el año -->
        <SankeyChart
          :key="selectedYear"
          :data="currentYearData.materiaprima.sankey"
        />
      </v-card>
    </div>
  </div>
</template>

<script>
import SankeyChart from '../components/charts/SankeyChart.vue';
import DonutChart2 from '../components/charts/DonutChart2.vue';
import { mapState, mapGetters } from 'vuex';
import YearPicker from '@/components/YearPicker.vue';
import { mockData } from '@/data/mockData.js';
import TopPanel from "@/components/layout/TopPanel.vue";

export default {
  name: 'MateriaPrimaView',
  data() {
    return {
      activeTab: 2,
      tabs: [
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' },
      ],
      chartOptions: {
        chart: { type: 'donut' },
        labels: ['Materia Prima', 'Residuos Orgánicos'],
        responsive: [
          {
            breakpoint: 480,
            options: { legend: { position: 'right' } },
          },
        ],
      },
    };
  },
  components: {
    SankeyChart,
    YearPicker,
    TopPanel,
    DonutChart2,
  },
  computed: {
    ...mapState(['selectedYear']),
    ...mapGetters(['availableYears']),

    currentYearData() {
      return mockData[this.selectedYear] || mockData['2024'];
    },
    materiaPrimaData() {
      return this.currentYearData?.resultados?.materiaPrima || {};
    },
  },
  methods: {
    navigateTo(index) {
      this.activeTab = index;
      this.$router.push({ path: this.tabs[index].path });
    },
    onYearChanged(newYear) {
      console.log(`📅 Cambio de año en Materia Prima: ${newYear}`);
      this.$store.commit('setSelectedYear', newYear);
      this.$store.dispatch('hydrateProducersByYear', newYear);
      //this.$store.commit('setSelectedProducer', null);
    },
  },
};
</script>

<style scoped>
#MateriaprimaView {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* --- Layout principal --- */
#wrapper {
  display: flex;
  align-items: stretch;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: space-between;
}

#left-wrapper,
#right-wrapper {
  height: 100%;
}

#left-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1vw;
  gap: 0.8vw;
  flex: 1 1 350px;   /* 🔥 Esto permite que baje correctamente */
  max-width: 420px;  /* límite razonable en desktop */
  min-width: 280px;
  box-sizing: border-box;
  background-color: #fff;
}

#right-wrapper {
  flex: 2 1 400px;
  height: auto;
  min-height: auto;
}

/* Evitar min-height de ApexCharts */
#right-wrapper .apexcharts-canvas {
  min-height: auto !important;
}

/* --- Tipografía responsiva --- */
.gray-font-text {
  color: #7F7F7F;
  font-weight: normal;
  padding: 0;
  margin: 0;
  font-size: clamp(12px, 0.9vw, 18px);
  line-height: 1.3;
}

h2.gray-font-text {
  font-size: clamp(16px, 1.3vw, 22px);
  font-weight: bold;
}

h3.gray-font-text {
  font-size: clamp(14px, 1.1vw, 20px);
  font-weight: 500;
}

p.gray-font-text {
  font-size: clamp(12px, 0.9vw, 18px);
  margin-bottom: 0.3em;
}

/* --- Botones --- */
.v-btn {
  font-size: clamp(10px, 0.8vw, 16px);
  text-transform: none;
  letter-spacing: 0.02em;
}

.active {
  background-color: #103E8E !important;
  color: white !important;
}

.unactive {
  color: #7F7F7F;
  background-color: #E0E0E0 !important;
}

/* --- Números destacados --- */
.mat_pri_number {
  color: #2F48A3;
  font-weight: bold;
  margin: 0;
  text-align: right;
  font-size: clamp(14px, 1.2vw, 24px);
  line-height: normal;
}

/* --- Header --- */
.header-bar {
  display: flex;
  align-items: center;
}

.header-bar h2 {
  margin: 0;
  padding: 0;
  line-height: 40px;
  font-size: clamp(16px, 1.2vw, 22px);
}

/* --- 🔹 MEDIA QUERIES RESPONSIVAS --- */

/* 🧩 Laptops pequeñas (≤1200px) */
@media (max-width: 1200px) {
  #left-wrapper {
    width: 35vw;
  }
}

/* 📱 Tablets (≤900px): layout vertical */
@media (max-width: 900px) {
  #wrapper {
    flex-direction: column;
  }

  #left-wrapper {
    width: 100%;
    padding: 3vw 4vw;
    gap: 1vw;
  }

  #right-wrapper {
    width: 100%;
    height: auto;
    max-height: 55vh;
    overflow-y: auto;
    min-height: 55vh;
  }

  .v-btn {
    font-size: clamp(12px, 1.8vw, 18px);
  }

  .mat_pri_number {
    font-size: clamp(16px, 2vw, 24px);
    text-align: left;
  }

  h2.gray-font-text,
  h3.gray-font-text,
  p.gray-font-text {
    text-align: left;
  }
}

/* 📲 Teléfonos (≤600px): mejora legibilidad */
@media (max-width: 600px) {
  #left-wrapper {
    width: 100% !important;
    max-width: 100%; /* 👈 Añade esto para anular el límite general de 420px */
    padding: 4vw;
  }
  #right-wrapper {
    width: 100%;
    height: auto;
    max-height: 400px;
  }

  .v-btn {
    font-size: clamp(14px, 2.5vw, 20px);
    margin: 2px;
    padding: 4px 8px;
  }

  h2.gray-font-text {
    font-size: clamp(18px, 3vw, 26px);
  }

  p.gray-font-text {
    font-size: clamp(14px, 2.5vw, 20px);
  }

  .mat_pri_number {
    font-size: clamp(18px, 3vw, 28px);
  }
}
</style>



